import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITranslatableText } from 'src/app/store/services/store.service';
import { SettingService } from './setting.service';
import { finalize, Observable } from 'rxjs';
import { ImageService } from './image.service';
import { ApiControllerService } from './api-controller.service';

export interface IRewards {
  id: string;
  merchantId: string;
  rewards: IReward[];
}

export interface IBaseRewardsRequest {
  merchantId: string;
}

export interface IReward {
  rewardName: ITranslatableText;
  rewardImg: IRewardImg;
  deactivate: boolean;
  linkedItemId: string;
  pointsCost: number;
  creationDate: Date;
  editingDate: Date;
  createdBy: string;
  lastEditedBy: string;
}

export interface IRewardImg {
  imgActiveShortName: string;
  imgActiveDisplayName: string;
  imgInactiveShortName: string;
  imgInactiveDisplayName: string;
}


export interface ImgPointsUrls {
  imgPointImg1: any,
  imgPointImg2: any,
  imgPointImg3: any,
  imgPointImg4: any
}

export interface IimageLibraryData {
  shortNameReference: string;
  valueImageCollected: string;
}

@Injectable({
  providedIn: 'root',
})
export class RewardsService {

  rewards: IRewards;

  imageLibrary: IimageLibraryData[] = [];

  imgUrls: ImgPointsUrls = {
    imgPointImg1: "",
    imgPointImg2: "",
    imgPointImg3: "",
    imgPointImg4: ""
  };
  
  constructor(
    private http: HttpClient,
    private settingService: SettingService,
    private imageService: ImageService,
    private apiController: ApiControllerService
  ) { }

  getRewards(rewardsRequest: IBaseRewardsRequest): Observable<IRewards> {
    return Observable.create(o => {
      if(this.rewards) {
        o.next(this.rewards);
        o.complete();
      } else {
        /* this.http.post(this.settingService.apiUrl('Rewards/GetRewards'), rewardsRequest)
          .subscribe((data: any) => {
            this.rewards = data;
            this.preloadImageData();
            o.next(data);
            o.complete();
          }); */

        this.apiController.post(this.settingService.apiUrl('Rewards/GetRewards'), rewardsRequest)
          .subscribe((data: any) => {
            this.rewards = data;
            this.preloadImageData();
            o.next(data);
            o.complete();
          });
      }
    })
  }

  // complimentary methods
  
  getImage(path: string): Observable<Blob> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('Menu/GetMenuItemImage'), {
        path: path
      }, { responseType: 'blob' })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          result => o.next(result),
          res => {
            if (res.status != 400)
              o.error(res);
          }
        ) */

      this.apiController.post(this.settingService.apiUrl('Menu/GetMenuItemImage'), {
        path: path
      }, { responseType: 'blob' })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          result => o.next(result),
          res => {
            if (res.status != 400)
              o.error(res);
          }
        )
    });
  }

  fetchImage(ImageShortname) {
    return new Promise((resolve, reject) => {
      if (ImageShortname != null && ImageShortname != "") {

        var imageData = this.preloadedImage(ImageShortname);

        if(imageData == "") {
          this.getImage(ImageShortname).subscribe(data => {
            this.imageService.createImageFromBlob(data)
            .pipe(finalize(() => {
                
            }))
            .subscribe((buffer) => {
              this.setloadedImage(ImageShortname, buffer);
              resolve(buffer);
            });       
          }, error => {
          });
        } else {
          resolve(imageData);
        }


        
      } else {
        resolve('');
      }
    });
  } 

  preloadImageData(){
    this.rewards.rewards.forEach(reward => {
      this.fetchImage(reward.rewardImg.imgActiveShortName);
      this.fetchImage(reward.rewardImg.imgInactiveShortName);
    });
  }

  setloadedImage(ImageShortname, imageBuffer) {
    var valueReference = {
      shortNameReference: ImageShortname,
      valueImageCollected: imageBuffer
    }

    this.imageLibrary.push(valueReference); 
  }

  preloadedImage(ImageShortname): string {
    const match = this.imageLibrary.find(
      item => item.shortNameReference === ImageShortname
    );


    if(match) {
      return match.valueImageCollected;
    } else {
      return "";
    }
  }
}
